var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"toggle-container"},[_c('div',{staticClass:"slider",style:({
      left: _vm.sliderLeft + 'px',
      width: _vm.sliderWidth + 'px'
    })}),_c('span',{ref:"option0",class:{ 'active' : _vm.selectedIndex === 0 },on:{"click":function($event){return _vm.select(0)}}},[_vm._v(" "+_vm._s(_vm.translate('rdCorporate'))+" ")]),_c('span',{ref:"option1",class:{'active' : _vm.selectedIndex === 1 },on:{"click":function($event){return _vm.select(1)}}},[_vm._v(" "+_vm._s(_vm.translate('rdPersonal'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }